import React, {useEffect, useState} from 'react';
import {
	expressInterestInLocation,
	handleApiResponse,
	logJsError,
} from '../../services/api.service';
import {
	getFromStore,
	saveToStore,
	StorePath,
	storeSaveAction,
	useStoreActionsFromStore,
} from '../../services/store.service';
import MessageModel from '../../models/message.model';
import {addLatestMessage} from '../../services/message.service';
import {snippetService} from '../../services/snippet.service';

const Locations = ({data}: {data: string[]}) => {
	const storeAction = useStoreActionsFromStore(storeSaveAction);
	const messages = getFromStore(StorePath.MESSAGES) as MessageModel[];
	const [selectedLocation, setSelectedLocation] = useState('');

	useEffect(() => {
		// Disable input when locations are displayed
		saveToStore(storeAction, StorePath.IS_LOCATION_SELECTION_ACTIVE, true);
		return () => {
			saveToStore(storeAction, StorePath.IS_LOCATION_SELECTION_ACTIVE, false);
		};
	}, []);

	const handleLocationSelection = (location: string): void => {
		snippetService.sendCtaClickMessage(location);
		setSelectedLocation(location);
		const typingTimeout = setTimeout(() => {
			saveToStore(storeAction, StorePath.AGENT_TYPING, true);
		}, 1300);

		expressInterestInLocation(location)
			.then(handleApiResponse)
			.then((data: any) => {
				addLatestMessage(data.messages, messages, storeAction);
				saveToStore(storeAction, StorePath.AGENT_TYPING, false);
				saveToStore(storeAction, StorePath.IS_LOCATION_SELECTION_ACTIVE, false);
				clearTimeout(typingTimeout);
			})
			.catch((error) => {
				clearTimeout(typingTimeout);
				saveToStore(storeAction, StorePath.AGENT_TYPING, false);
				saveToStore(storeAction, StorePath.IS_LOCATION_SELECTION_ACTIVE, false);
				logJsError(error);
			});
	};

	const isSelected = (location: string): boolean => {
		return selectedLocation === location;
	};

	return (
		<div className={'flex flex-col items-start'}>
			{data.map((location: string) => (
				<button key={location} className={`my-1 ml-10 p-2 rounded-sm border cursor-pointer ${isSelected(location) ? 'bg-primary text-white' : ''}`}
				     onClick={() => handleLocationSelection(location)}>
					<span className="whitespace-pre-line" style={{wordBreak: 'break-word'}}>
						 {location}
					</span>
				</button>
			))}
		</div>
	);
};

export default Locations;
